import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";
import Back from "../Components/back";
import walletTransaction from "../Api/walletTransaction";
import Swal from "sweetalert2";
import ModelLaunchEdit from "../Components/ModelLaunchEdit";

export default function TransactionHistory() {
  const navigate = useNavigate();
  const [transactionHistory, setTransactionHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [showSurveyEditModal, setShowSurveyEditModal] = useState(false)
  const [dataModal, setDataModal] = useState(null);


  const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

  const formatAMPM = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    return `${hours}:${minutes}${ampm}`;
  }

  // const getPrevious = () => {
  //   setCurrentPage(currentPage - 1)
  // }
  // const getNext = () => {
  //   setCurrentPage(currentPage + 1)
  // }

  // const handlePageSizeChange = (event) => {
  //   setPageSize(Number(event.target.value));
  //   setCurrentPage(0); // Reset currentPage when pageSize changes
  // };

  const handleSurveyEdit = (status, id) => {
    if (status.toLowerCase() === 'pending') {
      openLaunchEditModal(id)
      // navigate("/survey_edit", { state: id });
    }
  };

  useEffect(() => {
    const fetchWalletTransaction = async () => {
      const request = {
        currentPage: currentPage,
        pageSize: pageSize,
      }
      try {
        const result = await walletTransaction(request);
        setTransactionHistory(result.data);
      } catch (error) {
        console.error("API Error:", error.response.data.message);
        if (error.response.status === 401 || error.response.status === 500) {
          Toast.fire({
            icon: 'error',
            title: error.response.data.title
          })
          localStorage.clear();
          navigate("/");
        }
        Toast.fire({
          icon: 'error',
          title: error.response.data.message
        })
      }
    };
    fetchWalletTransaction();
  }, [setTransactionHistory, currentPage, pageSize]);

  const transactionsByStatus = {
    All: transactionHistory?.result?.content ?? [],
    Pending: transactionHistory?.result?.content?.filter((item) => item.status.toUpperCase() === "PENDING") ?? [],
    Completed: transactionHistory?.result?.content?.filter((item) => item.status.toUpperCase()  === "COMPLETED") ?? [],
    Rejected: transactionHistory?.result?.content?.filter((item) => item.status.toUpperCase()  === "REJECTED") ?? [],
  };

  const openLaunchEditModal = (trxId) => {
    setShowSurveyEditModal(true);
    setDataModal(trxId)
  };

  const closeLaunchEditModal = () => {
    setShowSurveyEditModal(false);
  };



  return (
    <>
      <div className="container mobile-page">

        <div className="container">
          <div className="row">
            <div className="col-2 d-flex align-items-center">
              <Back location={"/starting"}/>
            </div>
            <div className="col-8 text-center">
              <span className="fs-3 text-white fw-bold">Launch History</span>
            </div>
          </div>
        </div>


        <nav >
          <div className="nav nav-tabs mt-4 mb-4 d-flex flex-nowrap" id="nav-tab" role="tablist">
            <button className="nav-link active" id="nav-All-tab" data-bs-toggle="tab" data-bs-target="#nav-All"
                    type="button" role="tab" aria-controls="nav-All" aria-selected="true"
            >
              <span className='lightGrey fw-bold fs-6'>All</span>
            </button>
            <button className="nav-link" id="nav-Pending-tab" data-bs-toggle="tab" data-bs-target="#nav-Pending"
                    type="button" role="tab" aria-controls="nav-Pending" aria-selected="false"

            >
              <span className='lightGrey fw-bold fs-6'>Pending</span>
            </button>
            <button className="nav-link" id="nav-Completed-tab" data-bs-toggle="tab" data-bs-target="#nav-Completed"
                    type="button" role="tab" aria-controls="nav-Completed" aria-selected="false"

            >
              <span className='lightGrey fw-bold fs-6'>Completed</span>
            </button>
            <button className="nav-link" id="nav-Rejected-tab" data-bs-toggle="tab" data-bs-target="#nav-Rejected"
                    type="button" role="tab" aria-controls="nav-Rejected" aria-selected="false"

            >
              <span className='lightGrey fw-bold fs-6'>Frozen</span>
            </button>
          </div>
        </nav>
        <div className="my-2 divider-grey"></div>
        <div className="tab-content" id="nav-tabContent">
          <div className="tab-pane fade show active" id= {`nav-All`} role="tabpanel" aria-labelledby={`nav-All-tab`}
               tabIndex="0">
            {
              transactionsByStatus['All']?.map((list,index) => {
                console.log('transactionsByStatus[\'All\']',transactionsByStatus['All'])
                const time = new Date(list?.trxDateTime);
                const formattedTime = `${time.getFullYear()}-${(time.getMonth() + 1).toString().padStart(2, '0')}-${time.getDate().toString().padStart(2, '0')} | ${formatAMPM(time)}`;
                return (
                        <>
                          <div key={index} className="container">
                            <div className="row">
                              <div className="col-8">
                                <div className="mt-3 withdraw-time fs-6 text-white">{formattedTime}</div>
                              </div>
                              <div className="col-4 align-self-end">
                                <button className={`button-outline rounded-5 px-1 py-1 text-white ${list?.status.toLowerCase()}`} style={{ fontSize: '12px' }}>
                                  <span className='fw-bold'>{list?.status.toUpperCase()}</span>
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className="withdraw-tab mt-3 mb-3 p-4 rounded-4 light-black" onClick={() => handleSurveyEdit(list?.status, list?.id)}>
                            <div className="row align-items-center">
                              <div className="col-3 withdraw-image">
                                <img src={list?.productImage} alt='launch image'/>
                              </div>
                              <div className="col-7">
                                <div className="fs-6 text-white fw-bold">Purchase Brand - {list?.productName}</div>
                              </div>
                              <div className="my-3 divider-grey"></div>
                              <div className="row">
                                <div className="col-6 d-flex flex-column">
                                  <span className='fs-6 fw-bold text-pink'>Survey Value</span>
                                  <span className='fs-6 fw-bold text-white'>USDT {list?.surveyValue}</span>
                                  {/*<p className="fs-6 dollar" style={{ lineHeight: '24px' }}>{list?.trxDesc}</p>*/}
                                </div>
                                <div className="col-5 d-flex flex-column">
                                  <span className='fs-6 fw-bold text-pink'>Profit</span>
                                  <span className='fs-6 fw-bold text-white'>USDT {list?.amount}</span>
                                  {/*<p className="fs-6 dollar" style={{ lineHeight: '24px' }}>{list?.trxDesc}</p>*/}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                )
              })
            }
          </div>

          <div className="tab-pane fade" id= {`nav-Pending`} role="tabpanel" aria-labelledby={`nav-Pending-tab`}
               tabIndex="0">
            {
              transactionsByStatus['Pending']?.map((list, index) => {
                const time = new Date(list?.trxDateTime);
                const formattedTime = `${time.getFullYear()}-${(time.getMonth() + 1).toString().padStart(2, '0')}-${time.getDate().toString().padStart(2, '0')} | ${formatAMPM(time)}`;
                return (
                    <>
                      <div key={index}  className="container">
                        <div className="row">
                          <div className="col-8">
                            <div className="mt-3 withdraw-time fs-6 text-white">{formattedTime}</div>
                          </div>
                          <div className="col-4 align-self-end">
                            <button className={`button-outline rounded-5 px-1 py-1 text-white ${list?.status.toLowerCase()}`} style={{ fontSize: '12px' }}>
                              <span className='fw-bold'>{list?.status.toUpperCase()}</span>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="withdraw-tab mt-3 mb-3 p-4 rounded-4 light-black" onClick={() => handleSurveyEdit(list?.status, list?.id)}>
                        <div className="row align-items-center">
                          <div className="col-3 withdraw-image">
                            <img src={list?.productImage} alt='launch image'/>
                          </div>
                          <div className="col-7">
                            <div className="fs-6 text-white fw-bold">Purchase Brand - {list?.productName}</div>
                          </div>
                          <div className="my-3 divider-grey"></div>
                          <div className="row">
                            <div className="col-6 d-flex flex-column">
                              <span className='fs-6 fw-bold text-pink'>Survey Value</span>
                              <span className='fs-6 fw-bold text-white'>USDT {list?.surveyValue}</span>
                              {/*<p className="fs-6 dollar" style={{ lineHeight: '24px' }}>{list?.trxDesc}</p>*/}
                            </div>
                            <div className="col-5 d-flex flex-column">
                              <span className='fs-6 fw-bold text-pink'>Profit</span>
                              <span className='fs-6 fw-bold text-white'>USDT {list?.amount}</span>
                              {/*<p className="fs-6 dollar" style={{ lineHeight: '24px' }}>{list?.trxDesc}</p>*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                )
              })
            }
          </div>

          <div className="tab-pane fade" id= {`nav-Completed`} role="tabpanel" aria-labelledby={`nav-Completed-tab`}
               tabIndex="0">
            {
              transactionsByStatus['Completed']?.map((list,index) => {
                const time = new Date(list?.trxDateTime);
                const formattedTime = `${time.getFullYear()}-${(time.getMonth() + 1).toString().padStart(2, '0')}-${time.getDate().toString().padStart(2, '0')} | ${formatAMPM(time)}`;
                return (
                    <>
                      <div key={index}  className="container">
                        <div className="row">
                          <div className="col-8">
                            <div className="mt-3 withdraw-time fs-6 text-white">{formattedTime}</div>
                          </div>
                          <div className="col-4 align-self-end">
                            <button className={`button-outline rounded-5 px-1 py-1 text-white ${list?.status.toLowerCase()}`} style={{ fontSize: '12px' }}>
                              <span className='fw-bold'>{list?.status.toUpperCase()}</span>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="withdraw-tab mt-3 mb-3 p-4 rounded-4 light-black" onClick={() => handleSurveyEdit(list?.status, list?.id)}>
                        <div className="row align-items-center">
                          <div className="col-3 withdraw-image">
                            <img src={list?.productImage} alt='launch image'/>
                          </div>
                          <div className="col-7">
                            <div className="fs-6 text-white fw-bold">Purchase Brand - {list?.productName}</div>
                          </div>
                          <div className="my-3 divider-grey"></div>
                          <div className="row">
                            <div className="col-6 d-flex flex-column">
                              <span className='fs-6 fw-bold text-pink'>Survey Value</span>
                              <span className='fs-6 fw-bold text-white'>USDT {list?.surveyValue}</span>
                              {/*<p className="fs-6 dollar" style={{ lineHeight: '24px' }}>{list?.trxDesc}</p>*/}
                            </div>
                            <div className="col-5 d-flex flex-column">
                              <span className='fs-6 fw-bold text-pink'>Profit</span>
                              <span className='fs-6 fw-bold text-white'>USDT {list?.amount}</span>
                              {/*<p className="fs-6 dollar" style={{ lineHeight: '24px' }}>{list?.trxDesc}</p>*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                )
              })
            }
          </div>

          <div className="tab-pane fade" id= {`nav-Rejected`} role="tabpanel" aria-labelledby={`nav-Rejected-tab`}
               tabIndex="0">
            {
              transactionsByStatus['Rejected']?.map((list, index) => {
                const time = new Date(list?.trxDateTime);
                const formattedTime = `${time.getFullYear()}-${(time.getMonth() + 1).toString().padStart(2, '0')}-${time.getDate().toString().padStart(2, '0')} | ${formatAMPM(time)}`;
                return (
                    <>
                      <div key={index}  className="container">
                        <div className="row">
                          <div className="col-8">
                            <div className="mt-3 withdraw-time fs-6 text-white">{formattedTime}</div>
                          </div>
                          <div className="col-4 align-self-end">
                            <button className={`btn btn-outline-secondary rounded-5 px-1 py-1 text-white ${list?.status.toLowerCase()}`} style={{ fontSize: '12px' }}>
                              <span className='fw-bold'>{list?.status.toUpperCase()}</span>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="withdraw-tab mt-3 mb-3 p-4 rounded-4 light-black" onClick={() => handleSurveyEdit(list?.status, list?.id)}>
                        <div className="row align-items-center">
                          <div className="col-3 withdraw-image">
                            <img src={list?.productImage} alt='launch image'/>
                          </div>
                          <div className="col-7">
                            <div className="fs-6 text-white fw-bold">Purchase Brand - {list?.productName}</div>
                          </div>
                          <div className="my-3 divider-grey"></div>
                          <div className="row">
                            <div className="col-6 d-flex flex-column">
                              <span className='fs-6 fw-bold text-pink'>Survey Value</span>
                              <span className='fs-6 fw-bold text-white'>USDT {list?.surveyValue}</span>
                              {/*<p className="fs-6 dollar" style={{ lineHeight: '24px' }}>{list?.trxDesc}</p>*/}
                            </div>
                            <div className="col-5 d-flex flex-column">
                              <span className='fs-6 fw-bold text-pink'>Profit</span>
                              <span className='fs-6 fw-bold text-white'>USDT {list?.amount}</span>
                              {/*<p className="fs-6 dollar" style={{ lineHeight: '24px' }}>{list?.trxDesc}</p>*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                )
              })
            }
          </div>

        </div>


        {/*<div className="d-flex justify-content-center mt-4">*/}
        {/*  <button className="rounded-3 mx-2" disabled={currentPage === 0 ? true : false} onClick={getPrevious}>*/}
        {/*    PREVIOUS*/}
        {/*  </button>*/}

        {/*  <select className="form-select" style={{ width: '100px' }} value={pageSize}*/}
        {/*    onChange={handlePageSizeChange}>*/}
        {/*    <option value="10">10</option>*/}
        {/*    <option value="20">20</option>*/}
        {/*    <option value="30">30</option>*/}
        {/*  </select>*/}


        {/*  <button className="rounded-3 mx-2" disabled={!transactionHistory?.result?.content?.last} onClick={getNext}>*/}
        {/*    NEXT*/}
        {/*  </button>*/}
        {/*</div>*/}
      </div>
      {showSurveyEditModal && (
          <ModelLaunchEdit onClose={closeLaunchEditModal} trxId={dataModal} />
      )}
    </>
  );
}
